export default "__VITE_ASSET__4d49fd2b__"